import { useGetLoyaltyStatusQuery } from "@jti/store/slices/loyaltyApiSlice";
import { useLoyaltyRestrictedContent } from "@jti/ui";

export const useLoyaltyActiveStatus = (): boolean => {
  const { data: isActive } = useGetLoyaltyStatusQuery();

  const { isRestricted } = useLoyaltyRestrictedContent();

  if (isRestricted) {
    return false;
  }

  return isActive ?? false;
};
